<template>
  <v-container fluid>
    <v-row class="mb-2">
      <v-col>
        <div class="text-h3">
          {{ title }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <div class="entities-buttons">
          <template
            v-for="(item, i) in items"
          >
            <v-btn
              v-if="userCanAccessToRoute(item)"
              :key="`buttons-${ i }`"
              class="btn-big entities-buttons_item"
              @click="$router.push(item.path)"
            >
              <span class="entities-buttons_item_content d-flex align-center justify-center">
                <font-awesome-icon :icon="['fas', item.icon]" />
                <span class="entities-buttons_item_text">{{ item.name }}</span>
              </span>
            </v-btn>
          </template>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import permissions from '@/mixins/permissions'

  export default {
    name: 'MenuGroup',
    mixins: [permissions],
    props: {
      title: String,
      items: Array,
    },
    methods: {
      userCanAccessToRoute (item) {
        if (item.roles) {
          return this.userIs(item.roles)
        }

        if (item.permissions) {
          return this.userCan(item.permissions)
        }

        return true
      },
    },
  }
</script>

<style lang="less" scoped>
  .entities-buttons {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .v-btn {
        margin-right: 15px;
        margin-bottom: 15px;
        color: #000;
        //background-color: #fff !important;

        svg {
          font-size: 22px;
          margin-right: 10px;
          color: @color-primary;
        }

        &.btn-big {
          height: 80px !important;
          padding-left: 30px;
          padding-right: 50px;
          font-size: 15px;
          font-weight: 500;
          flex-basis: 31%;
          box-shadow: 0 3px 6px #00000029;
          border-radius: 0 0 10px 10px ;  //0 10px 0 10px;
          //flex-grow: 1;

          ::v-deep {
            .v-btn__content {
              max-width: 100%;
            }
          }

          .media-xl({
            font-size: 18px;
          });

          @media (max-width: 1600px) {
            font-size: 13px;
            .entities-buttons_item_text {
              white-space: normal;
              text-align: left;
              max-width: 70%;
            }

          }

        }
      }

        &_item_content {
          text-transform: none;
          width: 100%;
        }
    }
</style>
